import React, { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  name?: string;
  type?: string;
  schema?: object; // New prop for JSON-LD Structured Data
}

const SEO: React.FC<SEOProps> = ({ title, description, name = 'XCape', type = 'website', schema }) => {
  useEffect(() => {
    // Update Title
    document.title = `${title} | XCape`;

    // Helper function to update or create meta tags
    const updateMetaTag = (attributeName: string, attributeValue: string, content: string) => {
      let element = document.querySelector(`meta[${attributeName}="${attributeValue}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attributeName, attributeValue);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Update Standard Meta Tags
    updateMetaTag('name', 'description', description);
    updateMetaTag('name', 'keywords', `gps accuracy, signal calibration, location optimizer, gps fix, high precision location, tanpa root, ${name}, absensi online`);
    updateMetaTag('name', 'twitter:title', title);
    updateMetaTag('name', 'twitter:description', description);
    updateMetaTag('name', 'twitter:creator', name);
    updateMetaTag('name', 'twitter:card', 'summary_large_image');

    // Update Open Graph Tags
    updateMetaTag('property', 'og:title', title);
    updateMetaTag('property', 'og:description', description);
    updateMetaTag('property', 'og:type', type);
    updateMetaTag('property', 'og:site_name', name);

    // Handle JSON-LD Structured Data
    if (schema) {
      let script = document.querySelector('script[type="application/ld+json"]');
      if (!script) {
        script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    }

    return () => {
       // Cleanup optional
    };
  }, [title, description, name, type, schema]);

  return null;
};

export default SEO;